<template>
  <p class="text-muted-foreground text-xs mb-1 whitespace-nowrap"><slot></slot></p>
</template>
